export default __webpack_public_path__ + "static/media/b25.a69a143a.png";